import React from 'react';

function RentContract() {
  return (
    <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Contrat de Location – B01 & B01 Lite</h1>
      
      <p>
        <strong>Entre :</strong> <em>Baltee Mobility</em>, société spécialisée dans la conception,
        la distribution et la maintenance de dispositifs de mobilité innovants, dont le siège
        social est situé à l’adresse suivante : Place du Granier, 35135 Chantepie, immatriculée
        au Registre du Commerce et des Sociétés de Rennes sous le numéro B 913340691,
        ci-après désignée « Baltee » ou « le Loueur ».
      </p>

      <p>
        <strong>Et :</strong> Toute personne physique ou morale souscrivant à un abonnement de
        location pour les modèles <strong>B01</strong> ou <strong>B01 Lite</strong>, ci-après désignée
        « le Locataire ».
      </p>

      <h2>1. Objet du contrat</h2>
      <p>
        Le présent contrat a pour objet de définir les droits et obligations de Baltee et du
        Locataire dans le cadre de la location, sans engagement de durée, d’un dispositif de
        mobilité B01 ou B01 Lite. Les modalités de paiement, de livraison, d’utilisation, de
        maintenance et de restitution sont encadrées par les conditions ci-après.
      </p>

      <h2>2. Description du produit et champ d’application</h2>
      <p>
        Le B01 et le B01 Lite sont des solutions de mobilité conçues pour faciliter les
        déplacements urbains et périurbains. Chaque appareil est équipé d’un système de suivi et de
        commande à distance permettant, entre autres, l’activation ou la désactivation de
        l’appareil via une application dédiée.
      </p>
      <p>
        Le présent contrat s’applique à toute souscription à l’offre d’abonnement proposée par
        Baltee, qu’il s’agisse du B01 ou du B01 Lite. Le Locataire reconnaît avoir pris
        connaissance des informations relatives aux caractéristiques techniques, à l’autonomie de
        la batterie, aux recommandations d’entretien et d’usage, ainsi qu’aux obligations légales
        pour la conduite de ce type d’appareil.
      </p>

      <h2>3. Abonnement sans engagement</h2>
      <p>
        L’offre de location est proposée <strong>sans engagement de durée</strong>. Le Locataire est
        libre de résilier son abonnement à tout moment, dans les conditions décrites ci-après
        (article 6 – Résiliation).
      </p>
      <p>
        Le montant de l’abonnement mensuel est facturé selon les tarifs en vigueur au moment de la
        souscription, disponibles sur le site internet de Baltee. Le Loueur se réserve le droit de
        modifier ses tarifs. En cas de modification, Baltee informera le Locataire dans un délai
        raisonnable afin que ce dernier puisse décider de la poursuite ou non de l’abonnement.
      </p>

      <h2>4. Modalités de paiement</h2>
      <p>
        Le Locataire s’engage à payer mensuellement, par carte bancaire ou prélèvement automatique,
        le montant de l’abonnement correspondant. Le paiement doit être effectué avant le début de
        chaque période mensuelle. En cas de non-paiement ou de refus de prélèvement, Baltee se
        réserve le droit de suspendre ou de résilier l’accès au service selon les modalités
        exposées dans l’article 7 (Défaut de paiement).
      </p>
      <p>
        Tout retard de paiement pourra entraîner des frais de relance ou de gestion
        administrative, conformément à la législation en vigueur. Baltee se réserve également la
        possibilité de transmettre tout impayé à un service de recouvrement pour assurer le
        règlement des sommes dues.
      </p>

      <h2>5. Livraison et mise en service</h2>
      <p>
        Baltee s’engage à livrer l’appareil B01 ou B01 Lite à l’adresse indiquée par le Locataire
        lors de la souscription, ou à proposer une date et un lieu de retrait si le Locataire
        souhaite récupérer l’appareil en point de collecte. Les délais de livraison peuvent varier
        en fonction de la disponibilité des stocks et de la zone géographique.
      </p>
      <p>
        Une fois l’appareil livré, le Locataire devra télécharger l’application Baltee sur son
        smartphone, créer un compte utilisateur et activer le produit pour pouvoir commencer à
        l’utiliser. Cette mise en service est guidée par des tutoriels fournis par Baltee.
      </p>

      <h2>6. Résiliation de l’abonnement et retour du produit</h2>
      <p>
        Le Locataire peut résilier son abonnement à tout moment, <strong>sans pénalité ni frais de
        rupture</strong>, en notifiant Baltee via le formulaire de résiliation disponible sur son
        espace client ou par tout autre moyen écrit (courrier, e-mail). Suite à cette notification,
        le Locataire dispose de <strong>7 jours</strong> pour procéder au retour du produit selon
        les modalités suivantes :
      </p>
      <ul>
        <li>
          Un bon de retour prépayé est mis à la disposition du Locataire ; <strong>les frais de
          retour sont donc pris en charge par Baltee.</strong>  
        </li>
        <li>
          L’appareil doit être retourné dans un état conforme à l’usage normal et sans
          détérioration majeure qui ne relèverait pas d’une usure ordinaire. Toute pièce cassée ou
          manquante peut faire l’objet d’une facturation complémentaire.
        </li>
        <li>
          En cas de dépassement du délai de 7 jours ou de non-retour, <strong>une majoration</strong> 
          pourra être appliquée, correspondant à un montant forfaitaire et/ou au prix de l’appareil
          neuf, selon la situation. Baltee en informera préalablement le Locataire par e-mail ou
          courrier.
        </li>
      </ul>
      <p>Le mois en cours de la rupture sera à régler intégralement.</p>

      <h2>7. Défaut de paiement et désactivation à distance</h2>
      <p>
        Si l’abonnement mensuel n’est pas réglé à l’échéance prévue et après une relance restée
        sans effet, Baltee se réserve le droit de <strong>désactiver à distance</strong> le B01 ou
        le B01 Lite, le rendant ainsi inutilisable jusqu’à ce que la situation soit régularisée.
      </p>
      <p>
        Baltee pourra ensuite exiger la restitution de l’appareil. Dans l’éventualité où le
        Locataire ne procède pas à son retour, Baltee entamera les démarches nécessaires (facturation
        d’une majoration, recouvrement, procédure judiciaire etc.) pour récupérer l’appareil ou sa
        valeur.
      </p>

      <h2>8. Entretien, utilisation et responsabilité</h2>
      <p>
        Le Locataire s’engage à utiliser l’appareil loué conformément à sa destination normale et
        dans le respect des consignes de sécurité, des lois et règlements en vigueur. Toute
        modification technique non autorisée par Baltee est interdite.
      </p>
      <p>
        L’entretien courant (gonflage des pneus, nettoyage, vérification des freins etc.) est à la
        charge du Locataire, tandis que les réparations liées à un défaut de fabrication ou à un
        vice caché sont à la charge de Baltee, sous réserve que le Locataire avertisse rapidement
        Baltee de la panne ou du dysfonctionnement observé.
      </p>
      <p>
        Baltee recommande au Locataire de souscrire une assurance responsabilité civile couvrant
        l’utilisation de ce type d’engin de mobilité. Baltee ne saurait être tenue pour responsable
        des dommages causés par une utilisation inappropriée ou illicite de l’appareil.
      </p>

      <h2>9. Garantie et service après-vente</h2>
      <p>
        Dans le cadre de la location, le B01 ou le B01 Lite est couvert contre les pannes
        techniques imputables à un défaut de conception ou de fabrication. Le Locataire doit
        signaler immédiatement toute avarie à Baltee, qui fera ses meilleurs efforts pour fournir
        une assistance (téléphone, e-mail, application) et, si nécessaire, organiser la réparation
        ou l’échange de l’appareil dans les plus brefs délais.
      </p>

      <h2>10. Protection des données personnelles</h2>
      <p>
        Baltee collecte et traite certaines données personnelles du Locataire (coordonnées de
        contact, données de facturation, historiques de connexion etc.) dans le cadre de
        l’exécution du contrat. Ces données sont conservées pendant la durée de l’abonnement et
        peuvent être transmises à des prestataires chargés d’assurer le recouvrement en cas
        d’impayé.
      </p>
      <p>
        Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi
        Informatique et Libertés, le Locataire dispose d’un droit d’accès, de rectification, de
        suppression et d’opposition relatif à ses données personnelles, qu’il peut exercer en
        contactant Baltee par e-mail ou via le formulaire dédié sur le site.
      </p>

      <h2>11. Droit applicable et litiges</h2>
      <p>
        Le présent contrat est régi par le droit français. Tout différend relatif à son
        interprétation, sa validité ou son exécution sera soumis, à défaut d’accord amiable, aux
        tribunaux compétents du lieu du siège social de Baltee, sauf dispositions légales
        impératives contraires.
      </p>

      <h2>12. Dispositions finales</h2>
      <p>
        Dans l’éventualité où l’une des clauses du contrat serait jugée nulle ou inapplicable,
        totalement ou partiellement, les autres dispositions demeureront inchangées et garderont
        leur plein effet.  
      </p>
      <p>
        Le Locataire reconnaît avoir pris connaissance de l’intégralité des dispositions du
        présent contrat, en accepter toutes les conditions et s’engager à les respecter. 
      </p>
      <p>
        Le présent contrat constitue l’intégralité de l’accord entre Baltee et le Locataire
        concernant la location du B01 ou du B01 Lite. Aucun document ou déclaration non annexé ou
        cité explicitement ne pourra avoir d’effet juridique sur les obligations définies ci-dessus.
      </p>

      <h2>13. Communications et contact</h2>
      <p>
        Pour toute question ou demande d’information complémentaire, Baltee met à disposition du
        Locataire plusieurs canaux de communication :  
      </p>
      <ul>
        <li>Une ligne téléphonique dédiée au service client.</li>
        <li>Un formulaire de contact et un système de chat en ligne sur le site officiel.</li>
        <li>Une adresse e-mail de support qui permet d’obtenir des réponses techniques ou
            administratives.</li>
      </ul>
      <p>
        Baltee s’efforce de répondre dans les meilleurs délais et d’apporter des solutions
        appropriées pour garantir une utilisation optimale des appareils.
      </p>

      <h2>14. Droit de rétractation</h2>
      <p>
        Conformément aux dispositions légales relatives à la vente à distance, si le Locataire est
        un consommateur (personne physique non professionnelle), il dispose d’un délai de 14 jours
        suivant la réception de l’appareil pour exercer son droit de rétractation, sans avoir à se
        justifier ni à payer de pénalité, sous réserve de la remise en état d’origine de l’appareil
        et de l’absence de dommages.
      </p>
      <p>
        Si ce droit est exercé, Baltee procédera au remboursement des sommes versées (hors frais
        supplémentaires éventuellement engagés) dans un délai de 14 jours, à compter de la réception
        du produit retourné.
      </p>

      <p>
        <em>
          Fait à Paris, le [Date automatique], en deux exemplaires, dont un est remis au Locataire
          et l’autre conservé par Baltee Mobility.
        </em>
      </p>

    </div>
  );
}

export default RentContract;
